export const listIcd10Years = () => [2020, 2021, 2022, 2023, 2024, 2025];
